/**
 * Shared primitives for the inline "Create New Record" affordance in entity-record
 * pickers (ReferenceSelect, EmbeddedEntityUI). When the user has typed a search
 * query, the picker appends a synthetic option carrying `CREATE_RECORD_OPTION_VALUE`;
 * selecting it creates a record named with the query and selects it inline.
 * Firestore doc ids never collide with the sentinel, so it is safe to compare
 * against a selected value.
 */
import { FC } from 'react';
import { theme } from 'antd';
import Icon from '@/components/atoms/Icon';
import FlexBox from '@/components/atoms/FlexBox';

export const CREATE_RECORD_OPTION_VALUE = '__create-record__';

export const CreateRecordOptionLabel: FC<{ label: string }> = ({ label }) => {
  const { token } = theme.useToken();
  return (
    <FlexBox justifyStart noGrow gap={token.marginXXS}>
      <Icon.Plus size={14} />
      <span>{label}</span>
    </FlexBox>
  );
};
